import 'alpinejs'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//window.Vue = require('vue');
require('./bootstrap');




/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*Vue.component('example-component', require('./components/ExampleComponent.vue'));

const app = new Vue({
    el: '#app'
});*/

require('./Init');
require('./DataTables');
require('./DaysIntense');
require('./Fcm');
require('./TrackPlays');
require('./EmailManagement');
require('./Products');
require('./Widgets');
require('./Groups');
require('./Offices');
require('./TeamsOld');
require('./TeamMembers');
require('./CartAbandonmentReport');
require('./FormSubmissions');
require('./Playlists');
require('./LandingPages');
require('./PageCategories');
require('./ManualOrders');
require('./AlbumCategory');
require('./Albums');
require('./Resource');
require('./ResourceType');
require('./ResourceCategory');
require('./Teams');
require('./TeamAlbums');
require('./AlbumQuestion');
require('./AlbumAnswer');
require('./VideoReplays');
require('./QrCode');
require('./Jotforms');
require('./ShortUrls');
require('./Forms');
require('./MediaTranscoder');
require('./Users');
require('./AiChat');
require('./AiSettings');
